import React from 'react'
import SigninPage from 'src/app/Signin/SigninPage'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { signinRouteProps } from 'src/navigation/routeProps'

import { AppLocation } from '../appLocations'

const SigninAppRoute: AppRoute = {
  id: AppLocation.Signin,
  routeProps: signinRouteProps,
  component: <SigninPage />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default SigninAppRoute
